export enum WebProductHeaderTemplate {
    INITIAL,
    SCROLLED
}

export enum WebProductFooterTemplate {
    QUANTITY,
    CONFIRMATION
}